import apiClient from '../api.js';
import { conToken } from '../autorizacion.js';

// Capa de servicios de los eventos de cobro (un catálogo de eventos que se asocia
// a los ítems de cada plan económico) y del motor que genera la deuda con ellos
// (paso 2 de la generación de deuda).
// Backend: `UNICEN/modules/economico`. Contrato completo:
// UNICEN/modules/economico/docs/disparadores-cobro.openapi.yaml
//
// Token obligatorio, `{ data }`, errores `{ mensaje, campo? }` (leer con `errorDeApi`).
//
// Catálogo (el evento trae sus tramos; cada regla de cobro de TARIFAS apunta a un tramo):
//   GET    /economico/disparadores-cobro?incluir_inactivos                    -> { disparadores: [{ ..., tramos: [{ ..., reglas }] }] }
//   POST   /economico/disparadores-cobro { nombre, tipo_gestion, recursada, tipos_materia, tramos: [{ id_tramo?, desde, hasta, calculo }] }
//   PUT    /economico/disparadores-cobro/:id { ...lo mismo }                  -> { ..., reglas_afectadas }
//   DELETE /economico/disparadores-cobro/:id                                  -> { resultado: ELIMINADO | DADO_DE_BAJA }
//   POST   /economico/disparadores-cobro/:id/reactivar
//   GET    /economico/disparadores-cobro/:id/historial?pagina&limite
//   GET    /economico/disparadores-cobro/tipos-materia                        -> { tipos_materia }
// Vista de un plan (solo lectura):
//   GET    /economico/disparadores-cobro/planes/:id_plan?incluir_inactivos    -> { disparadores: [{ ..., tramos con las reglas del plan }] }
// Motor:
//   GET    /economico/generacion-deuda/simulacion?unicodigo&id_gestion&id_plan_estudio?
//          -> { contexto, materias, cobros, pendientes }

const resource = '/economico/disparadores-cobro';

const useDisparadoresCobroApi = {
  tiposMateria() {
    return apiClient.get(`${resource}/tipos-materia`, conToken());
  },

  // ── Catálogo ──────────────────────────────────────────────────────────────

  listar({ incluirInactivos } = {}) {
    return apiClient.get(resource, conToken({ params: { incluir_inactivos: incluirInactivos || undefined } }));
  },

  crear(evento) {
    return apiClient.post(resource, evento, conToken());
  },

  editar(idDisparador, evento) {
    return apiClient.put(`${resource}/${idDisparador}`, evento, conToken());
  },

  eliminar(idDisparador) {
    return apiClient.delete(`${resource}/${idDisparador}`, conToken());
  },

  reactivar(idDisparador) {
    return apiClient.post(`${resource}/${idDisparador}/reactivar`, {}, conToken());
  },

  historial(idDisparador, { pagina, limite } = {}) {
    return apiClient.get(`${resource}/${idDisparador}/historial`, conToken({ params: { pagina, limite } }));
  },

  // ── Vista de un plan (solo lectura) ───────────────────────────────────────

  listarDelPlan(idPlan, { incluirInactivos } = {}) {
    return apiClient.get(`${resource}/planes/${idPlan}`, conToken({ params: { incluir_inactivos: incluirInactivos || undefined } }));
  },

  /** Qué deuda se generaría hoy (no escribe). Sin plan de estudios, el de la única carrera inscrita. */
  simular({ unicodigo, idGestion, idPlanEstudio }) {
    return apiClient.get('/economico/generacion-deuda/simulacion', conToken({
      params: { unicodigo, id_gestion: idGestion, id_plan_estudio: idPlanEstudio || undefined },
    }));
  },
};

export default useDisparadoresCobroApi;
